import axios from 'axios';
import {AxiosRequestConfig, AxiosResponse, AxiosError} from 'axios';
import {ElMessage} from "element-plus";
import useUserStore from '@/stores/user';

// 创建axios实例
const instanceAI = new axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_AI,
  // baseURL:'https://isafety.zgcsafety.com.cn/aisafety',
  // baseURL:'http://192.168.8.106:8080',
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded'
    'Content-Type': 'application/json;charset=UTF-8'
  }
});

// 请求拦截器
instanceAI.interceptors.request.use((config: AxiosRequestConfig): any => {
  const userStore = useUserStore();
  // 可在请求发送前对config进行修改，如添加请求头等
  const headers = config.headers || {};
  headers['Authorization'] = userStore.user_token;
  headers['timestemp'] = userStore.timestemp;
  config.headers = headers;
  console.log('config=======', config)
  return config;
}, (error: AxiosError) => {
      // 处理请求错误
      return Promise.reject(error);
    }
);

// 响应拦截器
instanceAI.interceptors.response.use(
    (response: AxiosResponse) => {
      // 对响应数据进行处理
      return response;
    },
    (error: AxiosError) => {
      console.log('error', error, error.status)
      if (error) {
        let errorMessage = '系统内部异常，请联系网站管理员'
        switch (error.status) {
          case 404:
            ElMessage.error("很抱歉，资源未找到")
            break
          case 403:
            break
          case 401:
            ElMessage.error("很抱歉，您无法访问该资源，可能是因为没有相应权限或者登录已失效")
            setTimeout(() => {
              this.$handleStorage.clear()
              location.reload()
            }, 1000)
            break
          case 503:
            ElMessage.error(error.status + " -- 模块化服务尚未启动，请稍后重试")
            break
          default:
            ElMessage.error(errorMessage)
            break
        }
      }
      return Promise.reject({code: -1, msg: '失败'})
    }
);


export default instanceAI

// 封装GET请求
export function getAI(url, params) {
  return instanceAI.get(url, {params})
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
}

// 封装POST请求
export function postAI(url, params) {
  return instanceAI.post(url, params, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
  })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
}

// 封装文件上传请求
export function postAIUpFile(url, formData,) {
  return instanceAI.post(url, formData, {
    headers: {
      // 覆盖默认的Content-Type，使用multipart/form-data
      'Content-Type': 'multipart/form-data'
    },
  })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
}

// 封装DELETE请求
export function deleteAI(url) {
  return instanceAI.delete(url)
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
}
